import angular from 'angular';

class ModalUpdateAnnouncementCtrl {
    /*@ngInject*/
    constructor() {
    }

    confirm() {
        let vm = this;
        vm.modalInstance.close();

    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.announcement').component('modalUpdateAnnouncement', {
    templateUrl: require('./modal-update-announcement.html'),
    controller: ModalUpdateAnnouncementCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
